export default function getBeers(filterText)
{
    filterText = filterText ? filterText.replace(' ','_') : '';

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      console.log(filterText.length)

      if (filterText.length > 3)
      {
        xhr.open('GET', `${__myapp.env.API_URL}client/key/${filterText}`);
        xhr.send();

        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
              let dataaa = JSON.parse(xhr.response)
              setTimeout(resolve(dataaa.data.clients.sort((a, b) => {
                if (a.company > b.company) return 1;
                if (a.company < b.company) return -1;
              })), 2000);
          } else {
            reject()
          }
        };
      }
    });
  }